import { ModalForm } from 'modules/app/styles'
import { Col, ModalBody, Row } from 'reactstrap'
import { IntegrationBox } from 'modules/settings/styles'
import { ReactComponent as SlackIntegrationIcon } from 'assets/images/icons/SlackIntegration.svg'
import { ReactComponent as ZoomIntegration } from 'assets/images/icons/ZoomIntegration.svg'
import { ReactComponent as WebstoreIcon } from 'assets/images/icons/webstore.svg'
import { ReactComponent as SlackButton } from 'assets/images/icons/slack-button.svg'
import { ReactComponent as ZoomButton } from 'assets/images/icons/zoom-button.svg'
import { ReactComponent as MicrosoftIcon } from 'assets/images/icons/Microsoft_Edge_logo.svg'
import { CustomButton } from 'modules/auth/styles'
import { handleExternalLink } from 'utils/helpers'

export default function Integrations() {
  return (
    <ModalBody>
      <ModalForm>
        <div className='title'>Integrations</div>
        <br />
        <br />
        <Row>
          <Col className='mb-3' xs={12} xl={6}>
            <IntegrationBox>
              <div className='logo'>
                <WebstoreIcon />
              </div>
              <div className='content'>
                <div className='integration-name'>Chrome Extension</div>
                <div className='description'>Easily access and retrieve company knowledge while working in your Chrome browser with this extension.</div>
                <CustomButton
                  id='chrome-extension-button'
                  as='a'
                  href='https://chrome.google.com/webstore/detail/canned-responses-tray/iinfjdloicbbgbdliglpofadahlmgjop'
                  // href='https://klutch.nyc3.digitaloceanspaces.com/klutch-extension-v3.0.0.zip'
                  target='_blank'
                  onClick={handleExternalLink}
                  rel='noreferrer noopener'
                  className='mx-auto mx-xl-0 mr-xl-auto btn-sm light-blue-100 shadow-none '>
                  Add now
                </CustomButton>
              </div>
            </IntegrationBox>
          </Col>
          <Col className='mb-3' xs={12} xl={6}>
            <IntegrationBox>
              <div className='logo'>
                <MicrosoftIcon />
              </div>
              <div className='content'>
                <div className='integration-name'>Edge Add-on</div>
                <div className='description'>Easily access and retrieve company knowledge while working in your Edge browser with this add-on.</div>
                <CustomButton
                  id='edge-extension-button'
                  as='a'
                  href='https://microsoftedge.microsoft.com/addons/detail/klutch-canned-responses/ifehnjhpgkjapjpibniblcmgkmcgcnkc'
                  target='_blank'
                  onClick={handleExternalLink}
                  rel='noreferrer noopener'
                  className='mx-auto mx-xl-0 mr-xl-auto btn-sm light-blue-100 shadow-none '>
                  Add now
                </CustomButton>
              </div>
            </IntegrationBox>
          </Col>
          <Col className='mb-3' xs={12} xl={6}>
            <IntegrationBox>
              <div className='logo'>
                <SlackIntegrationIcon />
              </div>
              <div className='content'>
                <div className='integration-name'>Slack</div>
                <div className='description'>Add and share company knowledge and canned responses on Slack directly from your Klutch account</div>
                <CustomButton
                  as='a'
                  href='https://slack-app.klutch.app/installApp'
                  target='_blank'
                  onClick={handleExternalLink}
                  rel='noreferrer noopener'
                  className='mx-auto mx-xl-0 mr-xl-auto btn-sm light-blue-100 shadow-none slack-button'>
                  <SlackButton /> Add To Slack
                </CustomButton>
              </div>
            </IntegrationBox>
          </Col>
          <Col className='mb-3' xs={12} xl={6}>
            <IntegrationBox>
              <div className='logo zoom'>
                <ZoomIntegration />
              </div>
              <div className='content'>
                <div className='integration-name'>Zoom</div>
                <div className='description'>Manage your company's knowledge and resources directly within Zoom.</div>
                <CustomButton
                  as='a'
                  href='https://zoom.klutch.app/install'
                  target='_blank'
                  onClick={handleExternalLink}
                  rel='noreferrer noopener'
                  className='mx-auto mx-xl-0 mr-xl-auto btn-sm light-blue-100 shadow-none slack-button'>
                  <ZoomButton /> Add To Zoom
                </CustomButton>
              </div>
            </IntegrationBox>
          </Col>
          <Col className='mb-3' xs={12} xl={6}>
            <IntegrationBox>
              <div className='content'>
                <div className='integration-name my-4'>
                  More Awesome Integrations
                  <br />
                  coming soon...
                </div>
              </div>
            </IntegrationBox>
          </Col>
        </Row>
      </ModalForm>
    </ModalBody>
  )
}
